import React from 'react';
import { Platform } from 'react-native';

import Stack from '@components/Stack';

import type { SkeletonBlockProps } from './types';

if (Platform.OS === 'web' && typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = `
        @keyframes shimmerWave {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100vw); }
        }
    `;
    document.head.appendChild(style);
}

/**
 * Web build of the shimmering placeholder block (see `index.tsx` for native).
 * The shimmer runs as a CSS animation rather than through reanimated.
 */
const SkeletonBlock: React.FC<SkeletonBlockProps> = ({
    width,
    height,
    borderRadius,
    style,
    color = '#49B888'
}) => {
    return (
        <Stack
            style={[
                {
                    width,
                    height,
                    overflow: 'hidden',
                    backgroundColor: color,
                    borderRadius,
                    position: 'relative'
                },
                style
            ]}
        >
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '50%',
                    background:
                        'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%)',
                    animation: 'shimmerWave 1.5s infinite linear',
                    willChange: 'transform',
                    zIndex: 1
                }}
            />
        </Stack>
    );
};

export default SkeletonBlock;
